const SWEEP_DURATION_S = 6.4;
const LOGO_SIZE = 84;

const techLogos = [
  {
    id: 'python',
    label: 'Python',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
    x: '18%',
    y: '20%',
  },
  {
    id: 'html5',
    label: 'HTML5',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
    x: '34%',
    y: '14%',
  },
  {
    id: 'css3',
    label: 'CSS3',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg',
    x: '52%',
    y: '11%',
  },
  {
    id: 'javascript',
    label: 'JavaScript',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
    x: '70%',
    y: '16%',
  },
  {
    id: 'react',
    label: 'React',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
    x: '81%',
    y: '30%',
  },
  {
    id: 'nodejs',
    label: 'Node.js',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
    x: '15%',
    y: '47%',
  },
  {
    id: 'php',
    label: 'PHP',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg',
    x: '28%',
    y: '58%',
  },
  {
    id: 'flutter',
    label: 'Flutter',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg',
    x: '44%',
    y: '64%',
  },
  {
    id: 'git',
    label: 'Git',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg',
    x: '63%',
    y: '62%',
  },
  {
    id: 'mysql',
    label: 'MySQL',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg',
    x: '79%',
    y: '53%',
  },
  {
    id: 'postgresql',
    label: 'PostgreSQL',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
    x: '67%',
    y: '76%',
  },
  {
    id: 'mongodb',
    label: 'MongoDB',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
    x: '49%',
    y: '80%',
  },
  {
    id: 'android',
    label: 'Android',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg',
    x: '31%',
    y: '80%',
  },
  {
    id: 'bash',
    label: 'Terminal',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg',
    x: '18%',
    y: '71%',
  },
  {
    id: 'docker',
    label: 'Docker',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',
    x: '86%',
    y: '69%',
  },
  {
    id: 'java',
    label: 'Java',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',
    x: '9%',
    y: '30%',
  },
  {
    id: 'spring',
    label: 'Spring',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg',
    x: '57%',
    y: '28%',
  },
  {
    id: 'cplusplus',
    label: 'C++',
    src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg',
    x: '41%',
    y: '28%',
  },
]
  .map((item) => {
  const relativeX = parseFloat(item.x) - 50;
  const relativeY = parseFloat(item.y) - 50;
  const nodeAngle = (Math.atan2(relativeY, relativeX) * 180) / Math.PI;
  const normalizedAngle = (((nodeAngle % 360) + 360) % 360) / 360;

  return {
    ...item,
    phase: normalizedAngle,
    delay: `-${(normalizedAngle * SWEEP_DURATION_S).toFixed(2)}s`,
  };
  })
  .sort((first, second) => first.phase - second.phase);

function ProgrammingLanguageShowcase() {
  return (
    <div className="tech-logo-showcase tech-logo-showcase-minimal">
      <div className="tech-logo-field">
        <div className="tech-logo-grid" />
        <div className="tech-logo-glow tech-logo-glow-one" />
        <div className="tech-logo-glow tech-logo-glow-two" />
        <div className="tech-logo-glow tech-logo-glow-three" />
        <div className="tech-logo-sweep" />

        <div className="tech-logo-rings">
          <span className="tech-logo-ring ring-one" />
          <span className="tech-logo-ring ring-two" />
          <span className="tech-logo-ring ring-three" />
          <span className="tech-logo-core" />
        </div>

        {techLogos.map((item) => (
          <div
            className="tech-logo-node"
            key={item.id}
            style={{
              '--x': item.x,
              '--y': item.y,
              '--size': `${LOGO_SIZE}px`,
              '--tech-delay': item.delay,
              '--tech-duration': `${SWEEP_DURATION_S}s`,
            }}
          >
            <img alt={item.label} loading="lazy" referrerPolicy="no-referrer" src={item.src} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProgrammingLanguageShowcase;
